import { DataLogin } from './autenticacion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultadoServicio } from './lugares.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

const smartHomeUrl = 'https://as-ws-smarthome.azurewebsites.net/';

@Injectable({
  providedIn: 'root'
})
export class VisitantesService {

  constructor(private _http: HttpClient) { }

  traerVisitantes(
    page: number,
    estado: number,
    palabrasClave: string,
    fechaInicio: string,
    horaInicio: String,
    fechaFinal: string,
    horaFinal: string,
  ): Observable<ResultadoServicio<VisitantesUnidad>> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    let requestUrl = `${smartHomeUrl}api/visitantes/${loginData.company_id}?status=${estado}&
                                                                              key=${palabrasClave}&
                                                                              page=${page + 1}&
                                                                              cant=8&
                                                                              date_begin=${fechaInicio}&
                                                                              hour_begin=${horaInicio}&
                                                                              date_end=${fechaFinal}&
                                                                              hour_end=${horaFinal}`;

    requestUrl = requestUrl.replace(/(\r\n|\n|\r|\s)/gm, "");

    const headers = new HttpHeaders({
      'dataVisitantes': 'true'
    });

    return this._http.get<ResultadoServicio<VisitantesUnidad>>(requestUrl, { headers });
  }

  traerVisitante(id: string) {
    const requestUrl = `${smartHomeUrl}/api/visitantes/visitante/${id}`;

    const headers = new HttpHeaders({
      'dataVisitante': 'true'
    });

    return this._http.get<ResultadoServicio<DataVisitante>>(requestUrl, { headers });
  }

  crearVisitante(visitante: Visitante) {
    const requestUrl = `${smartHomeUrl}api/visitantes/new`;

    return this._http.post<ResultadoServicio<DataVisitante>>(requestUrl, visitante);
  }

  registrarVisitante(idVisitante: string) {
    const requestUrl = `${smartHomeUrl}/api/visitantes/visitante/checking/${idVisitante}`;


    return this._http.get<ResultadoServicio<DataVisitante>>(requestUrl);
  }
}

export interface VisitantesUnidad {
  visitantes: Visitante[]
}

export interface DataVisitante {
  data_visitante: Visitante
}

export interface Visitante {
  id?: number;
  user_id: number;
  name: string;
  type_document: string;
  number_document: string;
  date_checkin: Date;
  hour_checkin: string;
  hour_checkout: string;
  indicative: string;
  phone: string;
  type_vehicle: string;
  site_name: string;
  area_name: string;
  plate_vehicle: string;
  note: string;
  mark?: string;
  brand_vehicle?: string;
  status?: string;
  aut_name: string;
}

export enum TIPOS_VISITAS {
  VISITAS_PROGRAMADAS = 1,
  HISTORIAL = 0
}